    
// import * as firebase from 'firebase'
import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/database'
import "firebase/firestore"
import users from '../users/index'   
import DATA from './../../plugins/DATA' 
import DB from './../../plugins/DB'   
import  { 
  toDateTime, 
  toDate,
  toTime,
  TEXT_UP,
  TEXT_UP1,
  TEXT_UP11,
  TEXT_UP0,
  TEXT_EQ,
  TEXT_SPLIT_N,
  TEXT_SPACE0, 
  DEFINED_ONLY
} from './../../plugins/MBS_actions' 

import formatNumber  from '../../plugins/formatNumber'   
import moment from 'moment'     
const toNumber=formatNumber.toNumber
const toMoney=formatNumber.toMoney
const toSameLength=formatNumber.toSameLength
 
//ref
let REF_ERRORS = null
let REF_MESSAGES = null
let REF_NOTIFICATIONS = null
let REF_ID_TYPES = null
let REF_OCCURRENCES = null
let REF_REPORTERS = null 
let REF_REPORTER_CATEGORIES = null 

let REF_COUNTRIES = null
let REF_REGIONS = null
let REF_DISTRICTS = null 
let REF_CONSTITUENCIES = null 
let REF_WARDS = null 
let REF_CENTRES = null 
let REF_TRADITION_AUTHORITIES = null 

let REF_QUESTION_TYPES = null
let REF_QUESTION_CATEGORIES = null
let REF_QUESTION_TIMELINES = null
let REF_QUESTION_STAGES = null
let REF_TRACKING_UPDATES = null 

let REF_QUESTIONNAIRES = null
let REF_REPORTS = null 
let REF_WEB_REPORTS = null 
let REF_WHATSAPP_REPORTS = null 
let REF_MOBILE_REPORTS = null 
let REF_SMS_REPORTS = null 
let REF_PERSONAL_REPORTS = null 
 

let NAME = "STORE-ITEM"

export default{
    state: {  
      ERRORS:null, 
      MESSAGES:null, 
      NOTIFICATIONS:null,
      SERVICES:null, 
      ID_TYPES:null, 
      OCCURRENCES:null, 
      REPORTERS:null, 
      REPORTER_CATEGORIES:null, 
      WEB_REPORTS:null, 
      WHATSAPP_REPORTS:null, 
      MOBILE_REPORTS:null, 
      SMS_REPORTS:null, 
      PERSONAL_REPORTS:null, 
      
      COUNTRIES:null,  
      REGIONS:null,  
      DISTRICTS:null, 
      CONSTITUENCIES:null, 
      WARDS:null, 
      CENTRES:null, 
      TRADITION_AUTHORITIES:null, 

      QUESTION_TYPES:null, 
      QUESTION_CATEGORIES:null, 
      QUESTION_TIMELINES:null, 
      QUESTION_STAGES:null, 
      QUESTIONNAIRES:null, 
 
    },
    //___________________-GETTERS-_________________
    getters: {  
      getItemsState(state) { 
        return state
      }, 
      getAppErrors(state) {
        return state.ERRORS 
      }, 
      getAppErrorByKey(state) {
        return key=>{
          if(!key){return null}
          if(!state.ERRORS){return null}
          return state.ERRORS.find(ct=>{
            return ct.key == key
          }) 
        }
      },  
      getMessages(state) {
        return state.MESSAGES
      }, 
      getNotification(state) {
        return state.NOTIFICATIONS
      }, 
      getIdTypes(state) {
        return state.ID_TYPES 
      },   
      getIdTypeByKey(state) {
        return key=>{
          if(!key){return null}
          if(!state.ID_TYPES){return null}
          return state.ID_TYPES.find(ct=>{
            return ct.key == key
          }) 
        }
      }, 
      getIdTypeByCode(state) {
        return code=>{
          if(!code){return null}
          if(!state.ID_TYPES){return null}
          return state.ID_TYPES.find(ct=>{
            return ct.code == code
          }) 
        }
      },  
      getOccurrences(state) {
        return state.OCCURRENCES 
      }, 
      getOccurrenceByKey(state) {
        return key=>{
          if(!key){return null}
          if(!state.OCCURRENCES){return null}
          return state.OCCURRENCES.find(ct=>{
            return ct.key == key
          }) 
        }
      }, 
      getOccurrenceByCode(state) {
        return code=>{
          if(!code){return null}
          if(!state.OCCURRENCES){return null}
          return state.OCCURRENCES.find(ct=>{
            return ct.code == code
          }) 
        }
      }, 
      getReporters(state) {
        return state.REPORTERS 
      }, 
      getReporterByKey(state) {
        return key=>{
          if(!key){return null}
          if(!state.REPORTERS){return null}
          return state.REPORTERS.find(ct=>{
            return ct.key == key
          }) 
        }
      }, 
      getReporterByCode(state) {
        return code=>{
          if(!code){return null}
          if(!state.REPORTERS){return null}
          return state.REPORTERS.find(ct=>{
            return ct.code == code
          }) 
        }
      }, 
      
      getReporterCategories(state) {
        return state.REPORTER_CATEGORIES 
      }, 
      getReporterCategoryByKey(state) {
        return key=>{
          if(!key){return null}
          if(!state.REPORTER_CATEGORIES){return null}
          return state.REPORTER_CATEGORIES.find(ct=>{
            return ct.key == key
          }) 
        }
      }, 
      getReporterCategoryByCode(state) {
        return code=>{
          if(!code){return null}
          if(!state.REPORTER_CATEGORIES){return null}
          return state.REPORTER_CATEGORIES.find(ct=>{
            return ct.code == code
          }) 
        }
      }, 

      getCountries(state) {
        return state.COUNTRIES 
      }, 
      getCountryByKey(state) {
        return key=>{
          if(!key){return null}
          if(!state.COUNTRIES){return null}
          return state.COUNTRIES.find(ct=>{
            return ct.key == key
          }) 
        }
      }, 
      getCountryByCode(state) {
        return code=>{
          if(!code){return null}
          if(!state.COUNTRIES){return null}
          return state.COUNTRIES.find(ct=>{
            return ct.code == code
          }) 
        }
      }, 
      getRegions(state) {
        return state.REGIONS 
      }, 
      getRegionByKey(state) {
        return key=>{
          if(!key){return null}
          if(!state.REGIONS){return null}
          return state.REGIONS.find(ct=>{
            return ct.key == key
          }) 
        }
      }, 
      getRegionByCode(state) {
        return code=>{
          if(!code){return null}
          if(!state.REGIONS){return null}
          return state.REGIONS.find(ct=>{
            return ct.code == code
          }) 
        }
      }, 
      getDistricts(state) {
        return state.DISTRICTS 
      }, 
      getDistrictByKey(state) {
        return key=>{
          if(!key){return null}
          if(!state.DISTRICTS){return null}
          return state.DISTRICTS.find(ct=>{
            return ct.key == key
          }) 
        }
      }, 
      getDistrictByCode(state) {
        return code=>{
          if(!code){return null}
          if(!state.DISTRICTS){return null}
          return state.DISTRICTS.find(ct=>{
            return ct.code == code
          }) 
        }
      }, 
      getConstituencies(state) {
        return state.CONSTITUENCIES 
      }, 
      getConstituencyByKey(state) {
        return key=>{
          if(!key){return null}
          if(!state.CONSTITUENCIES){return null}
          return state.CONSTITUENCIES.find(ct=>{
            return ct.key == key
          }) 
        }
      }, 
      getConstituencyByCode(state) {
        return code=>{
          if(!code){return null}
          if(!state.CONSTITUENCIES){return null}
          return state.CONSTITUENCIES.find(ct=>{
            return ct.code == code
          }) 
        }
      }, 
      getWards(state) {
        return state.WARDS 
      }, 
      getWardByKey(state) {
        return key=>{
          if(!key){return null}
          if(!state.WARDS){return null}
          return state.WARDS.find(ct=>{
            return ct.key == key
          }) 
        }
      }, 
      getWardByCode(state) {
        return code=>{
          if(!code){return null}
          if(!state.WARDS){return null}
          return state.WARDS.find(ct=>{
            return ct.code == code
          }) 
        }
      }, 
      getCentres(state) {
        return state.CENTRES 
      }, 
      getCentreByKey(state) {
        return key=>{
          if(!key){return null}
          if(!state.CENTRES){return null}
          return state.CENTRES.find(ct=>{
            return ct.key == key
          }) 
        }
      }, 
      getCentreByCode(state) {
        return code=>{
          if(!code){return null}
          if(!state.CENTRES){return null}
          return state.CENTRES.find(ct=>{
            return ct.code == code
          }) 
        }
      }, 
      
      getQuestionTypes(state) {
        return state.QUESTION_TYPES 
      }, 
      getQuestionTypeByKey(state) {
        return key=>{
          if(!key){return null}
          if(!state.QUESTION_TYPES){return null}
          return state.QUESTION_TYPES.find(ct=>{
            return ct.key == key
          }) 
        }
      }, 
      getQuestionTypeByCode(state) {
        return code=>{
          if(!code){return null}
          if(!state.QUESTION_TYPES){return null}
          return state.QUESTION_TYPES.find(ct=>{
            return ct.code == code
          }) 
        }
      }, 
      getQuestionCategories(state) {
        return state.QUESTION_CATEGORIES 
      }, 
      getQuestionCategoryByKey(state) {
        return key=>{
          if(!key){return null}
          if(!state.QUESTION_CATEGORIES){return null}
          return state.QUESTION_CATEGORIES.find(ct=>{
            return ct.key == key
          }) 
        }
      }, 
      getQuestionCategoryByCode(state) {
        return code=>{
          if(!code){return null}
          if(!state.QUESTION_CATEGORIES){return null}
          return state.QUESTION_CATEGORIES.find(ct=>{
            return ct.code == code
          }) 
        }
      }, 
      getQuestionTimelines(state) {
        return state.QUESTION_TIMELINES 
      }, 
      getQuestionTimelineByKey(state) {
        return key=>{
          if(!key){return null}
          if(!state.QUESTION_TIMELINES){return null}
          return state.QUESTION_TIMELINES.find(ct=>{
            return ct.key == key
          }) 
        }
      }, 
      getQuestionTimelineByCode(state) {
        return code=>{
          if(!code){return null}
          if(!state.QUESTION_TIMELINES){return null}
          return state.QUESTION_TIMELINES.find(ct=>{
            return ct.code == code
          }) 
        }
      }, 
      getQuestionStages(state) {
        return state.QUESTION_STAGES 
      }, 
      getQuestionStageByKey(state) {
        return key=>{
          if(!key){return null}
          if(!state.QUESTION_STAGES){return null}
          return state.QUESTION_STAGES.find(ct=>{
            return ct.key == key
          }) 
        }
      }, 
      getQuestionStageByCode(state) {
        return code=>{
          if(!code){return null}
          if(!state.QUESTION_STAGES){return null}
          return state.QUESTION_STAGES.find(ct=>{
            return ct.code == code
          }) 
        }
      }, 
      getOccurrences(state) {
        return state.OCCURRENCES 
      }, 
      getOccurrenceByKey(state) {
        return key=>{
          if(!key){return null}
          if(!state.OCCURRENCES){return null}
          return state.OCCURRENCES.find(ct=>{
            return ct.key == key
          }) 
        }
      }, 
      getOccurrenceByCode(state) {
        return code=>{
          if(!code){return null}
          if(!state.OCCURRENCES){return null}
          return state.OCCURRENCES.find(ct=>{
            return ct.code == code
          }) 
        }
      }, 
      
      getQuestionnaires(state) {
        return state.QUESTIONNAIRES 
      }, 
      getQuestionnaireByKey(state) {
        return key=>{
          if(!key){return null}
          if(!state.QUESTIONNAIRES){return null}
          return state.QUESTIONNAIRES.find(ct=>{
            return ct.key == key
          }) 
        }
      }, 
      getQuestionnaireByCode(state) {
        return code=>{
          if(!code){return null}
          if(!state.QUESTIONNAIRES){return null}
          return state.QUESTIONNAIRES.find(ct=>{
            return ct.code == code
          }) 
        }
      },
      getQuestionnaireByOccurrenceCode(state) {
        return code=>{
          if(!code){return null}
          if(!state.QUESTIONNAIRES){return null}
          return state.QUESTIONNAIRES.filter(ct=>{
            return ct.occurrence_code == code
          }) 
        }
      },
      getWebReportsByOccurrenceCode(state) {
        return code=>{
          if(!code){return null}
          if(!state.WEB_REPORTS){return null}
          return state.WEB_REPORTS.filter(ct=>{
            return ct.occurrence_code == code
          }) 
        }
      },
      getMobileReportsByOccurrenceCode(state) {
        return code=>{
          if(!code){return null}
          if(!state.MOBILE_REPORTS){return null}
          return state.MOBILE_REPORTS.filter(ct=>{
            return ct.occurrence_code == code
          }) 
        }
      },
      getReports(state) {
        return state.REPORTS 
      }, 
      getReportByKey(state) {
        return key=>{
          if(!key){return null}
          if(!state.REPORTS){return null}
          return state.REPORTS.find(ct=>{
            return ct.key == key
          }) 
        }
      }, 
      getReportByCode(state) {
        return code=>{
          if(!code){return null}
          if(!state.REPORTS){return null}
          return state.REPORTS.find(ct=>{
            return ct.code == code
          }) 
        }
      }, 
      getMessages(state) {
        return state.MESSAGES 
      }, 
      getMessageByKey(state) {
        return key=>{
          if(!key){return null}
          if(!state.MESSAGES){return null}
          return state.MESSAGES.find(ct=>{
            return ct.key == key
          }) 
        }
      }, 
      getMessageByCode(state) {
        return code=>{
          if(!code){return null}
          if(!state.MESSAGES){return null}
          return state.MESSAGES.find(ct=>{
            return ct.code == code
          }) 
        }
      }, 
      
       
      
       
      getItems(state) {
        return state.ITEMS 
      },  
      getItemByKey(state) {
        return key=>{
          if(!key){return null}
          if(!state.ITEMS){return null}
          return state.ITEMS.find(item=>{
            return item.key == key
          }) 
        }
      }, 
      getItemByCode(state) {
        return code=>{
          if(!code){return null}
          if(!state.ITEMS){return null}
          return state.ITEMS.find(item=>{
            return item.code == code
          }) 
        }
      }, 
      getItemCategories(state) {
        return state.ITEM_CATEGORIES 
      },  
      getItemCategoryByKey(state) {
        return key=>{
          if(!key){return null}
          if(!state.ITEM_CATEGORIES){return null}
          return state.ITEM_CATEGORIES.find(item=>{
            return item.key == key
          }) 
        }
      },
      getItemCategoryByCode(state) {
        return code=>{
          if(!code){return null}
          if(!state.ITEM_CATEGORIES){return null}
          return state.ITEM_CATEGORIES.find(item=>{
            return item.code == code
          }) 
        }
      },
       
      
       
    },
    //___________________-MUTATIONS-___________________
    mutations:{  
      setItems(state, payload) {
        try {
          let name = payload?payload.name:null
          let data = payload?payload.data:null
          state[name]=data  
        } catch (error) {
          console.log(error);
        }
      },  
      updateItems(state, payload) {
        try {
          let name = payload?payload.name:null
          let data = payload?payload.data:null
          let stateData = state[name]
          if (stateData && data) {
            data = [
              ...stateData,
              ...data
            ]
          }
          state[name]=data  
        } catch (error) {
          console.log(error);
        }
      }, 
      updateItemsByKey(state, payload) {
        try {
          let name = payload?payload.name:null
          let data = payload?payload.data:null
          let stateData =[]
          if (state[name]) {stateData = [...state[name] ]}  
          if (data) {  
            for (const element of data) {
              var foundIndex = stateData.findIndex(x => x.key == element.key); 
              if(foundIndex != -1) { 
                stateData[foundIndex] = element;
              }else{
                stateData.push(element)
              } 
            }  
            state[name]=stateData
          }
        } catch (error) {
          console.log(error);
        }
      }, 
      restItems(state, payload) {
        try {
          let name = payload?payload.name:null 
          state[name]=null  
        } catch (error) {
          console.log(error);
        }
      },  
    },
    //____________________[ACTIONS]_____________________
    actions: {  
      initialize_items_ref({commit,dispatch},payload) {
        return new Promise(async(resolve,reject)=>{
          let response = {
            from:'initialize_items_ref',
            page:NAME,
            payload:payload

          }
          try {  
            let P_SERVER = (DATA.APP.SERVER+'/').toUpperCase()
            let P_SETTINGS = (DATA.APP.SERVER+'/SETTINGS/').toUpperCase()
            let P_ERRORS = '/'+DATA.ITEMS.ERRORS.values.toUpperCase()+'/'
            let P_MESSAGES = P_SERVER+DATA.ITEMS.MESSAGES.values.toUpperCase()+'/' 

            let name = payload?payload.name:null
            await dispatch("off_refs",{name:name})
            if (!name) {
              REF_ERRORS= firebase.database().ref(P_ERRORS) 
              REF_MESSAGES = firebase.database().ref(DATA.PATHS.messages) 
              REF_OCCURRENCES = firebase.database().ref(DATA.PATHS.occurrences) 
              REF_REPORTERS = firebase.database().ref(DATA.PATHS.reporters) 
              REF_REPORTER_CATEGORIES = firebase.database().ref(DATA.PATHS.reporter_categories) 

              REF_COUNTRIES = firebase.database().ref(DATA.PATHS.countries)  
              REF_REGIONS= firebase.database().ref(DATA.PATHS.regions)  
              REF_DISTRICTS = firebase.database().ref(DATA.PATHS.districts)  
              REF_CONSTITUENCIES = firebase.database().ref(DATA.PATHS.constituencies)  
              REF_WARDS = firebase.database().ref(DATA.PATHS.wards)  
              REF_CENTRES = firebase.database().ref(DATA.PATHS.centres)  
              REF_TRADITION_AUTHORITIES= firebase.database().ref(DATA.PATHS.tradition_authorities)  

              REF_QUESTION_TYPES = firebase.database().ref(DATA.PATHS.question_types)  
              REF_QUESTION_CATEGORIES = firebase.database().ref(DATA.PATHS.question_categories)  
              REF_QUESTION_TIMELINES = firebase.database().ref(DATA.PATHS.question_timelines)  
              REF_QUESTION_STAGES = firebase.database().ref(DATA.PATHS.question_stages)  

              REF_QUESTIONNAIRES = firebase.database().ref(DATA.PATHS.questionnaires)  
              REF_REPORTS = firebase.database().ref(DATA.PATHS.reports)  
              REF_WEB_REPORTS = firebase.database().ref(DATA.PATHS.web_reports)  
              REF_WHATSAPP_REPORTS = firebase.database().ref(DATA.PATHS.whatsapp_reports)  
              REF_MOBILE_REPORTS = firebase.database().ref(DATA.PATHS.mobile_reports)  
              REF_SMS_REPORTS = firebase.database().ref(DATA.PATHS.sms_reports)   
              REF_TRACKING_UPDATES = firebase.database().ref(DATA.PATHS.tracking_updates)  
            }else if (name == DATA.ITEMS.ERRORS.values) {
              REF_ERRORS= firebase.database().ref(P_ERRORS) 
            }else if (name == DATA.ITEMS.MESSAGES.values) {
              REF_MESSAGES = firebase.database().ref(P_MESSAGES) 
            }else if (name == DATA.ITEMS.OCCURRENCES.values) {
              REF_OCCURRENCES = firebase.database().ref(DATA.PATHS.occurrences)  
            }else if (name == DATA.ITEMS.REPORTERS.values) {
              REF_REPORTERS = firebase.database().ref(DATA.PATHS.reporters)  
            }else if (name == DATA.ITEMS.REPORTER_CATEGORIES.values) {
              REF_REPORTER_CATEGORIES = firebase.database().ref(DATA.PATHS.reporter_categories)  
            }else if (name == DATA.ITEMS.WEB_REPORTS.values) {
              REF_WEB_REPORTS = firebase.database().ref(DATA.PATHS.web_reports)  
            }else if (name == DATA.ITEMS.WHATSAPP_REPORTS.values) {
              REF_WHATSAPP_REPORTS = firebase.database().ref(DATA.PATHS.whatsapp_reports)  
            }else if (name == DATA.ITEMS.MOBILE_REPORTS.values) {
              REF_MOBILE_REPORTS = firebase.database().ref(DATA.PATHS.mobile_reports)  
            }else if (name == DATA.ITEMS.SMS_REPORTS.values) {
              REF_SMS_REPORTS = firebase.database().ref(DATA.PATHS.sms_reports)  
            }
            
            else if (name == DATA.ITEMS.COUNTRIES.values) {
              REF_COUNTRIES = firebase.database().ref(DATA.PATHS.countries)  
            }else if (name == DATA.ITEMS.REGIONS.values) {
              REF_REGIONS = firebase.database().ref(DATA.PATHS.regions)  
            }else if (name == DATA.ITEMS.DISTRICTS.values) {
              REF_DISTRICTS = firebase.database().ref(DATA.PATHS.districts)  
            }else if (name == DATA.ITEMS.CONSTITUENCIES.values) {
              REF_CONSTITUENCIES = firebase.database().ref(DATA.PATHS.constituencies)  
            }else if (name == DATA.ITEMS.WARDS.values) {
              REF_WARDS = firebase.database().ref(DATA.PATHS.wards)  
            }else if (name == DATA.ITEMS.CENTRES.values) {
              REF_CENTRES = firebase.database().ref(DATA.PATHS.centres)  
            }else if (name == DATA.ITEMS.TRADITION_AUTHORITIES.values) {
              REF_TRADITION_AUTHORITIES = firebase.database().ref(DATA.PATHS.tradition_authorities)  
            }
            
            else if (name == DATA.ITEMS.QUESTION_TYPES.values) {
              REF_QUESTION_TYPES = firebase.database().ref(DATA.PATHS.centres)  
            }else if (name == DATA.ITEMS.QUESTION_CATEGORIES.values) {
              REF_QUESTION_CATEGORIES = firebase.database().ref(DATA.PATHS.centres)  
            }else if (name == DATA.ITEMS.QUESTION_TIMELINES.values) {
              REF_QUESTION_TIMELINES = firebase.database().ref(DATA.PATHS.centres)  
            }else if (name == DATA.ITEMS.QUESTION_STAGES.values) {
              REF_QUESTION_STAGES = firebase.database().ref(DATA.PATHS.centres)  
            } 
            
            else if (name == DATA.ITEMS.QUESTIONNAIRES.values) {
              REF_QUESTIONNAIRES = firebase.database().ref(DATA.PATHS.questionnaires)  
            }else if (name == DATA.ITEMS.REPORTS.values) {
              REF_REPORTS = firebase.database().ref(DATA.PATHS.reports)  
            }else if (name == DATA.ITEMS.TRACKING_UPDATES.values) {
              REF_REPORTS = firebase.database().ref(DATA.PATHS.tracking_updates)  
            }  
            else {
              response.error = "name not found"
              reject(response)
            } 

            resolve({success:true}) 
          } catch (error) {
            commit("ERROR",{
              error:error,
              from:'initialize_items_ref',
              page:NAME, 
            })
            response.error = error
            reject(response)
          } 
        })
      },   
      initialize_uid_items_ref({commit,dispatch},payload) {
        return new Promise(async(resolve,reject)=>{
          let response = {
            from:'initialize_uid_items_ref',
            page:NAME,
            payload:payload 
          }
          try {   
            let uid = payload?payload.uid:null
            if (!uid) {
              response.error = "no uid"
              reject(response)
            } 
            let linkPath = (link)=>{
              return link+uid
            } 
 
            
            let name = payload?payload.name:null
            await dispatch("off_refs",{name:name})
            if (!name) {
              REF_PERSONAL_REPORTS = firebase.database().ref(linkPath(DATA.PATHS.personal_report))  
            }else if (name == DATA.ITEMS.PERSONAL_REPORTS) {
              REF_PERSONAL_REPORTS = firebase.database().ref(linkPath(DATA.PATHS.personal_report))  
            }else {
              response.error = "name not found"
              reject(response)
            } 

            resolve({
              success:true
            }) 
          } catch (error) {
            commit("ERROR",{
              error:error,
              from:'initialize_uid_items_ref',
              page:NAME, 
            })
            response.error = error
            reject(response)
          } 
        })
      }, 
      off_refs({commit},payload) {
        return new Promise((resolve,reject)=>{
          let response = {
            from:'off_refs',
            page:NAME,
            payload:payload
          }
          try {   
            let name = payload?payload.name:null
            if (!name) {
              if (REF_ERRORS) { REF_ERRORS.off() }
              if (REF_MESSAGES) { REF_MESSAGES.off() }
              if (REF_NOTIFICATIONS) { REF_NOTIFICATIONS.off() }
              if (REF_COUNTRIES) { REF_COUNTRIES.off() }
              if (REF_REGIONS) { REF_REGIONS.off() }
              if (REF_DISTRICTS) { REF_DISTRICTS.off() }
              if (REF_ID_TYPES) { REF_ID_TYPES.off() }
              if (REF_OCCURRENCES) { REF_OCCURRENCES.off() }
              if (REF_REPORTERS) { REF_REPORTERS.off() }
              if (REF_REPORTER_CATEGORIES) { REF_REPORTER_CATEGORIES.off() }
              if (REF_WEB_REPORTS) {REF_WEB_REPORTS.off() }
              if (REF_WHATSAPP_REPORTS) { REF_WHATSAPP_REPORTS.off() }
              if (REF_MOBILE_REPORTS) { REF_MOBILE_REPORTS.off() }
              if (REF_SMS_REPORTS) { REF_SMS_REPORTS.off() }
              if (REF_PERSONAL_REPORTS) { REF_PERSONAL_REPORTS.off() }

              if (REF_COUNTRIES) {REF_COUNTRIES.off() }
              if (REF_DISTRICTS) {REF_DISTRICTS.off() }
              if (REF_CONSTITUENCIES) {REF_CONSTITUENCIES.off() }
              if (REF_WARDS) {REF_WARDS.off() }
              if (REF_CENTRES) {REF_CENTRES.off() } 
              if (REF_TRADITION_AUTHORITIES) {REF_TRADITION_AUTHORITIES.off() } 
              if (REF_TRACKING_UPDATES) {REF_TRACKING_UPDATES.off() } 
            }else if (name == DATA.ITEMS.ERRORS.values) {
              if (REF_ERRORS) { REF_ERRORS.off() }
            }else if (name == DATA.ITEMS.MESSAGES.values) {
              if (REF_MESSAGES) { REF_MESSAGES.off() }
            }else if (name == DATA.ITEMS.NOTIFICATIONS.values) {
              if (REF_NOTIFICATIONS) { REF_NOTIFICATIONS.off() }
            }else if (name == DATA.ITEMS.COUNTRIES.values) {
              if (REF_COUNTRIES) { REF_COUNTRIES.off() }
            }else if (name == DATA.ITEMS.REGIONS.values) {
              if (REF_REGIONS) { REF_REGIONS.off() }
            }else if (name == DATA.ITEMS.DISTRICTS.values) {
              if (REF_DISTRICTS) { REF_DISTRICTS.off() }
            }else if (name == DATA.ITEMS.ID_TYPES.values) {
              if (REF_ID_TYPES) { REF_ID_TYPES.off() }
            }else if (name == DATA.ITEMS.OCCURRENCES.values) {
              if (REF_OCCURRENCES) { REF_OCCURRENCES.off() }
            }else if (name == DATA.ITEMS.REPORTERS.values) {
              if (REF_REPORTERS) { REF_REPORTERS.off() }
            }else if (name == DATA.ITEMS.REPORTER_CATEGORIES.values) {
              if (REF_REPORTER_CATEGORIES) { REF_REPORTER_CATEGORIES.off() }
            } else if (name == DATA.ITEMS.WEB_REPORTS.values) {
              if (REF_WEB_REPORTS) { REF_WEB_REPORTS.off() }
            } else if (name == DATA.ITEMS.WHATSAPP_REPORTS.values) {
              if (REF_WHATSAPP_REPORTS) { REF_WHATSAPP_REPORTS.off() }
            } else if (name == DATA.ITEMS.MOBILE_REPORTS.values) {
              if (REF_MOBILE_REPORTS) { REF_MOBILE_REPORTS.off() }
            } else if (name == DATA.ITEMS.SMS_REPORTS.values) {
              if (REF_SMS_REPORTS) { REF_SMS_REPORTS.off() }
            }else if (name == DATA.ITEMS.PERSONAL_REPORTS.values) {
              if (REF_PERSONAL_REPORTS) { REF_PERSONAL_REPORTS.off() }
            } 
            
            else if (name == DATA.ITEMS.COUNTRIES.values) {
              if (REF_COUNTRIES) { REF_COUNTRIES.off() }
            }else if (name == DATA.ITEMS.REGIONS.values) {
              if (REF_REGIONS) { REF_REGIONS.off() }
            }else if (name == DATA.ITEMS.DISTRICTS.values) {
              if (REF_DISTRICTS) { REF_DISTRICTS.off() }
            }else if (name == DATA.ITEMS.CONSTITUENCIES.values) {
              if (REF_CONSTITUENCIES) { REF_CONSTITUENCIES.off() }
            }else if (name == DATA.ITEMS.WARDS.values) {
              if (REF_WARDS) { REF_WARDS.off() }
            }else if (name == DATA.ITEMS.CENTRES.values) {
              if (REF_CENTRES) { REF_CENTRES.off() }
            }else if (name == DATA.ITEMS.TRADITION_AUTHORITIES.values) {
              if (REF_TRADITION_AUTHORITIES) { REF_TRADITION_AUTHORITIES.off() }
            } 
            
            else if (name == DATA.ITEMS.QUESTION_TYPES.values) {
              if (REF_QUESTION_TYPES) { REF_QUESTION_TYPES.off() }
            }else if (name == DATA.ITEMS.QUESTION_CATEGORIES.values) {
              if (REF_QUESTION_CATEGORIES) { REF_QUESTION_CATEGORIES.off() }
            }else if (name == DATA.ITEMS.QUESTION_TIMELINES.values) {
              if (REF_QUESTION_TIMELINES) { REF_QUESTION_TIMELINES.off() }
            }else if (name == DATA.ITEMS.QUESTION_STAGES.values) {
              if (REF_QUESTION_STAGES) { REF_QUESTION_STAGES.off() }
            } 
            
            else if (name == DATA.ITEMS.QUESTIONNAIRES.values) {
              if (REF_QUESTIONNAIRES) { REF_QUESTIONNAIRES.off() }
            }else if (name == DATA.ITEMS.REPORTS.values) {
              if (REF_REPORTS) { REF_REPORTS.off() }
            }else if (name == DATA.ITEMS.TRACKING_UPDATES.values) {
              if (REF_TRACKING_UPDATES) { REF_TRACKING_UPDATES.off() }
            }else {   
              response.error = "name not found"
              reject(response)
            } 
            resolve({
              success:true
            }) 
          } catch (error) {
            commit("ERROR",{
              error:error,
              from:'off_refs',
              page:NAME, 
            })
            response.error = error
            reject(response)
          } 
        })
      }, 
      fi_tracker({ commit,dispatch},payload){
        return new Promise(async(resolve,reject)=>{
          let response = {
            from:'fi_tracker',
            page:NAME,
            payload:payload,
          }
          try { 
            let names = payload?payload.names:null 
            let max_records = payload?payload.max_records:null
            max_records = max_records?max_records:50
            if (!names) {
              reject({...response,error:"payload required"})
              return
            } 
            //----GET LOCALS AND DATA SAVE
            for (const item of names) { 
              if (!item.data_save) {
                // dispatch("off_refs",item)
                dispatch('fi_get_item',{
                  ...item
                }) 
              } else {
                if (item.get) {
                  let name = item.name
                  commit('updateProcesses', {
                    add: true,
                    name: 'local_getting/'+name
                  }) 
                  let db_res = await DB.getItems({
                    name:name, 
                  })
                  let data = db_res?db_res.data:null
                  commit('updateProcesses', { 
                    name: 'local_getting/'+name
                  }) 
                  dispatch("f_save_items",{
                    name:name,
                    data:data,
                    db:true
                  })  
                }    
              }
            }

            //-----START TRACKING
            setTimeout(() => {
              REF_TRACKING_UPDATES.on('value', async data => {
                let obj = data.val()
                let i = 1
                let updates = []
                for (const key in obj) {
                  let item = obj[key]  
                  item = {
                    i:i,
                    key:key,
                    number : item
                  }  
                  updates.push(item)  
                  i++
                } 
                if (updates.length>0) {
                  //---------[GET UPDATES]------
                  let db_res = await DB.getItems({
                    name:DATA.ITEMS.TRACKING_UPDATES.values, 
                  }) 
                  let local_updates = db_res?db_res.data:null
                  let findUpdate = (records,name)=>{
                    if(!records||!name){return null}
                    return records.find(item=>item.key.toUpperCase() == name.toUpperCase())
                  }


                  //---------[CHECK DATA]------
                  names.forEach(async element => {
                    // RUN DATA SAVE
                    if (element.data_save) {
                      let name = element.name
                      if (!name) {
                        commit("ERROR",{...response,error:"no name"})
                        return
                      }
                      let link_key = DATA.PATHS.tracking_keys+(name.toUpperCase())+"/"
                      let path_key = await dispatch("company_link",{link:link_key,})
                      let ref_key = firebase.database().ref(path_key)  
                      let this_update = findUpdate(updates,name)
                      let this_local_update = findUpdate(local_updates,name)
                      let update_number = toNumber(this_update?this_update.number:0)
                      let local_update_number = toNumber(this_local_update?this_local_update.number:0)
                      let db_res = await DB.getItems({
                        name:DATA.ITEMS.TRACKING_KEYS.values, 
                        key:name, 
                      })
                      let local_key = db_res?db_res.data:null
                      let local_keys = local_key?local_key.keys:null 


                      let download_key = false
                      if (update_number == 0) {
                        download_key = false
                      }else if (update_number == local_update_number) {
                        download_key = false
                      }else{
                        download_key = true
                      } 
    
                      if (download_key) {
                        // console.log(name,'start....');
                        // await dispatch('fi_get_item',{
                        //   name:name,
                        //   cash:true,
                        // }) 
                        
                        // console.log(name,'updated....');
                        ref_key.once('value', async data => {
                          let obj = data.val()
                          let i = 1
                          let keys = []
                          for (const key in obj) {
                            let item = obj[key]  
                            item = {
                              i:i,
                              key:key,
                              ...item
                            }  
                            keys.push(item)  
                            i++
                          } 
                          
  
                          if (keys) { 
                            await dispatch('fi_get_item',{
                              name:name,
                              cash:true,
                              child_keys:keys,
                              local_child_keys:local_keys
                            }) 
                          } 
                          //---- UPDATE KEYS
                          DB.addItems({
                            name:DATA.ITEMS.TRACKING_KEYS.values, 
                            data:{
                              key:name, 
                              keys:keys
                            }, 
                          })
                        }) 
                      }else{
                        console.log(update_number,local_update_number,name,'same key......',name);
                      }  
                    } else {
                      
                    }
                  }); 
                }

                DB.addItems({
                  name:DATA.ITEMS.TRACKING_UPDATES.values,
                  data:updates
                }) 
                resolve({success:true,data:updates})
                // await dispatch('f_save_items',{...ref_action,data:data})
              })  
            }, 100);
          } catch (error) {
            response = {...response,error:error}
            commit("ERROR",response)
            reject(response)
          } 
        }) 
      },
      combine_data({},payload){
        let response = {
          from:'combine_data',
          page:NAME,
          payload:payload,
        }
        try {
          let data1 = payload?payload.data1:null
          let data2 = payload?payload.data2:null 
          if (!data1) {data1 = []}  
          if (data2) {  
            for (const element of data2) {
              var foundIndex = data1.findIndex(x => x.key == element.key); 
              if(foundIndex != -1) { 
                data1[foundIndex] = element;
              }else{
                data1.push(element)
              } 
            }  
          }
          return data1 
        } catch (error) {
          response = {...response,error:error}
          commit("ERROR",response)
          reject(response)
        }
      },
       
      //-----------------[ EXIST]---------------
      fs_exist({ commit, state },payload) {
        try {
          let action = payload.action
          let path = payload.path
          let exist = payload.exist 
          let exRef = firebase.firestore().collection(path).where(exist.path,"==",exist.value)
          exRef.get().then(snapshot=>{
            var newData = [];
            snapshot.forEach(function(doc) { 
                newData.push({
                  ...doc.data(),
                  key:doc.id
                });
            }); 

            console.log(newData);
          }).catch(error=>{
            console.log(error,'33333333333');
          }) 
        } catch (error) {
          commit("ERROR",{
            error:error,
            from:'fs_exist',
            page:NAME, 
          })
        } 
      },
      //-----------------[ FI ADD]---------------
      fi_add({ commit}, payload) {
        return new Promise((resolve,reject)=>{
          let response = {
            from:'fi_add',
            page:NAME, 
            payload:payload
          }
          try {
            let action = payload.action
            let path = payload.path
            let data = payload.data
            let no_frag = payload.multiple
            let us = users?users.state.USER:null
            let uid = us?us.uid:null 
            if (!uid) {
              commit('updateResponses', {
                res: 'adding/'+action+'/error',
                val: "no action"
              })
              reject({
                ...response,
                error:"no uid"
              })
              return
            } 
            //not
            commit('updateLoading', true)
            commit('updateProcesses', {
              add: true,
              name: 'adding/'+action
            }) 
            if (action) { 
              let dt = new Date
              let date = dt.toISOString()
              let record = data
              if (!no_frag) {
                record = {
                  ...data,
                  created_uid:uid,
                  created_at:date,
                  created_at_server:firebase.database.ServerValue.TIMESTAMP
                } 
              } 
              let ref = firebase.database().ref(path).push(record)
              ref.then(res => {
                //not
                commit('updateLoading', false)
                commit('updateProcesses', { 
                  name: 'adding/'+action
                })
                commit('updateResponses', {
                  res: 'adding/'+action+'/successful',
                  val: res
                })
                resolve({
                  success:true,
                  data:res
                })
              }).catch(error => {
                //not
                commit('updateLoading', false)
                commit('updateProcesses', { 
                  name: 'adding/'+action
                })
                commit('updateResponses', {
                  res: 'adding/'+action+'/error',
                  val: error
                })
                commit("ERROR",{
                  page:NAME,
                  from:"fi_add",
                  error:error
                })
                reject({
                  ...response,
                  error:error
                })
              })
            } else {
              //not
              commit('updateLoading', false)
              commit('updateProcesses', { 
                value: 'adding/'+action
              })
              commit('updateResponses', {
                res: 'adding/'+action+'/error',
                val: "no action"
              })
              commit("ERROR",{
                page:NAME,
                from:"fi_add",
                error:'no user'
              })
              reject({
                ...response,
                error:"no user"
              })
            } 
          } catch (error) {
            commit("ERROR",{
              error:error,
              from:'fi_add',
              page:NAME, 
            })
            reject({
              ...response,
              error:error
            })
          }
        })
      }, 
      fi_add_array({ commit}, payload) {
        return new Promise((resolve,reject)=>{
          let response = {
            from:'fi_add_array',
            page:NAME, 
            payload:payload
          }
          try {
            let action = payload.action
            let path = payload.path
            let items = payload.items
            let us = users?users.state.USER:null
            let uid = us?us.uid:null 
            if (!uid) {
              commit('updateResponses', {
                res: 'adding/'+action+'/error',
                val: "no action"
              })
              reject({
                ...response,
                error:"no uid"
              })
              return
            } 
            //not
            commit('updateLoading', true)
            commit('updateProcesses', {
              add: true,
              name: 'adding/'+action
            }) 
            if (action) { 
              let dt = new Date
              let date = dt.toISOString()
              let ref = firebase.database().ref(path)
              let res = []
              let res_error = []
              let index = 0
              items.forEach(async data => {
                index = index+1
                try {
                  let record = {
                    ...data,
                    created_uid:uid,
                    created_at:date,
                    created_at_server:firebase.database.ServerValue.TIMESTAMP
                  }
                  res.push(await ref.push(record)) 
                  
                } catch (error) {
                  res_error.push(error)
                }
                if (items.length == index) {
                  if (res_error.length == 0) {
                    //not
                    commit('updateLoading', false)
                    commit('updateProcesses', { 
                      name: 'adding/'+action
                    })
                    commit('updateResponses', {
                      res: 'adding/'+action+'/successful',
                      val: res
                    })
                    resolve({
                      success:true,
                      data:res
                    }) 
                  } else {
                    //not
                    commit('updateLoading', false)
                    commit('updateProcesses', { 
                      value: 'adding/'+action
                    })
                    commit('updateResponses', {
                      res: 'adding/'+action+'/error',
                      val: "no action"
                    })
                    commit("ERROR",{
                      page:NAME,
                      from:"fi_add",
                      error:{
                        errors:res_error,
                        error:"some item not added"
                      }
                    })
                    reject({
                      ...response,
                      error:res_error
                    })
                  }  
                }
                
              });

            } else {
              //not
              commit('updateLoading', false)
              commit('updateProcesses', { 
                value: 'adding/'+action
              })
              commit('updateResponses', {
                res: 'adding/'+action+'/error',
                val: "no action"
              })
              commit("ERROR",{
                page:NAME,
                from:"fi_add",
                error:'no user'
              })
              reject({
                ...response,
                error:"no user"
              })
            } 
          } catch (error) {
            commit("ERROR",{
              error:error,
              from:'fi_add',
              page:NAME, 
            })
            reject({
              ...response,
              error:error
            })
          }
        })
      }, 
      fs_add({ commit}, payload) {
        try {
          let action = payload.action
          let path = payload.path
          let data = payload.data
          let us = users?users.state.USER:null
          let uid = us?us.uid:null 
          if (!uid) {
            commit('updateResponses', {
              res: 'adding/'+action+'/error',
              val: "no action"
            })
            console.log("no uid.....");
            return
          }
  
          //not
          commit('updateLoading', true)
          commit('updateProcesses', {
            add: true,
            name: 'adding/'+action
          }) 
          if (action) { 
            let dt = new Date
            let date = dt.toISOString()
            let record = {
              ...data,
              created_uid:uid,
              created_at:date,
              created_at_server:firebase.firestore.FieldValue.serverTimestamp()
            }
            let fsRef = firebase.firestore().collection(path).add(record)
            
            fsRef.then(res => {
              //not
              commit('updateLoading', false)
              commit('updateProcesses', { 
                name: 'adding/'+action
              })
              commit('updateResponses', {
                res: 'adding/'+action+'/successful',
                val: res
              })
            }).catch(error => {
              //not
              commit('updateLoading', false)
              commit('updateProcesses', { 
                name: 'adding/'+action
              })
              commit('updateResponses', {
                res: 'adding/'+action+'/error',
                val: error
              })
              commit("ERROR",{
                page:NAME,
                from:"fs_add",
                error:error
              })
            })
          } else {
            //not
            commit('updateLoading', false)
            commit('updateProcesses', { 
              value: 'adding/'+action
            })
            commit('updateResponses', {
              res: 'adding/'+action+'/error',
              val: "no action"
            })
            commit("ERROR",{
              page:NAME,
              from:"fs_add",
              error:'no user'
            })
          } 
        } catch (error) {
          commit("ERROR",{
            error:error,
            from:'fs_add',
            page:NAME, 
          })
        }
      },
      //-----------------[ FI UPDATE]---------------
      fi_update({ commit}, payload) {
        return new Promise((resolve,reject)=>{
          let response = {
            from:'fi_update',
            page:NAME, 
            payload:payload
          }
          try {
            let action = payload.action
            let path = payload.path
            let data = payload.data
            let uid = payload.uid
            let no_frag = payload.no_frag
            if (!uid) {
              let us = users?users.state.USER:null
              uid = us?us.uid:null  
            }

            if (!uid) {
              commit('updateResponses', {
                res: 'updating/'+action+'/error',
                val: "no action"
              })
              reject({
                ...response,
                error:"no uid"
              })
              return
            } 
    
            //not
            commit('updateLoading', true)
            commit('updateProcesses', {
              add: true,
              name: 'updating/'+action
            }) 
            if (action) { 
              let dt = new Date
              let date = dt.toISOString()
              let record = data
              if (!no_frag) {
                record = {
                  ...record,
                  updated_uid:uid,
                  updated_at:date,
                  updated_at_server:firebase.database.ServerValue.TIMESTAMP
                }
              }
              console.log(path,'path......');
              console.log(record,'record......');
              let ref = firebase.database().ref(path).update(record)
              ref.then(res => {
                console.log(res,'r---------');
                //not
                commit('updateLoading', false)
                commit('updateProcesses', { 
                  name: 'updating/'+action
                })
                commit('updateResponses', {
                  res: 'updating/'+action+'/successful',
                  val: res
                })
                resolve({
                  success:true,
                  data:res
                })
              }).catch(error => {
                console.log(error,'error---------');
                //not
                commit('updateLoading', false)
                commit('updateProcesses', { 
                  name: 'updating/'+action
                })
                commit('updateResponses', {
                  res: 'updating/'+action+'/error',
                  val: error
                })
                commit("ERROR",{
                  page:NAME,
                  from:"fi_update",
                  error:error
                })
                reject({
                  ...response,
                  error:error
                })
              })
            } else {
              //not
              commit('updateLoading', false)
              commit('updateProcesses', { 
                name: 'updating/'+action
              })
              commit('updateResponses', {
                res: 'updating/'+action+'/error',
                val: "no action"
              })
              commit("ERROR",{
                page:NAME,
                from:"fi_update",
                error:'no action'
              })
              reject({
                ...response,
                error:"no action"
              })
            } 
          } catch (error) {
            commit("ERROR",{
              error:error,
              from:'fi_update',
              page:NAME, 
            })
            reject({
              ...response,
              error:error
            })
          }
        })
      }, 
      fs_update({ commit}, payload) {
        try {
          let action = payload.action
          let path = payload.path
          let data = payload.data
          let us = users?users.state.USER:null
          let uid = us?us.uid:null 
          if (!uid) {
            commit('updateResponses', {
              res: 'adding/'+action+'/error',
              val: "no action"
            })
            console.log("no uid.....");
            return
          } 
          //not
          commit('updateLoading', true)
          commit('updateProcesses', {
            add: true,
            name: 'updating/'+action
          }) 
          if (action) { 
            let dt = new Date
            let date = dt.toISOString()
            let record = {...data,updated_uid:uid,updated_at:date,updated_at_server:firebase.firestore.FieldValue.serverTimestamp()}
            console.log(path);
  
            
            let ref = firebase.firestore().doc(path).update(record)
            ref.then(res => {
              //not
              commit('updateLoading', false)
              commit('updateProcesses', { 
                name: 'updating/'+action
              })
              commit('updateResponses', {
                res: 'updating/'+action+'/successful',
                val: res
              })
            }).catch(error => {
              //not
              commit('updateLoading', false)
              commit('updateProcesses', { 
                name: 'updating/'+action
              })
              commit('updateResponses', {
                res: 'updating/'+action+'/error',
                val: error
              })
              commit("ERROR",{
                page:NAME,
                from:"fs_update",
                error:error
              })
            })
          } else {
            //not
            commit('updateLoading', false)
            commit('updateProcesses', { 
              name: 'updating/'+action
            })
            commit('updateResponses', {
              res: 'updating/'+action+'/error',
              val: "no action"
            })
            commit("ERROR",{
              page:NAME,
              from:"fs_update",
              error:'no user'
            })
          } 
        } catch (error) {
          commit("ERROR",{
            error:error,
            from:'fs_update',
            page:NAME, 
          })
        }
      }, 
      fi_set({ commit, dispatch}, payload) {
        return new Promise(async(resolve,reject)=>{
          let response = {
            from:'fi_set',
            page:NAME, 
          }
          let action = payload.action
          let path = payload.path
          let path_invalid = payload.path_invalid
          let data = payload.data
          let us = users?users.state.USER:null
          let uid = us?us.uid:null  
          let array = payload.array   
          let download_data = payload.download_data   
          let PATH_REF = firebase.database().ref(path)
          try { 
            commit('updateLoading', true)
            commit('updateProcesses', {
              add: true,
              name: 'setting/'+action
            }) 
            if (action && uid && path && data) { 
              let dt = new Date
              let date = dt.toISOString()
              let record =array?data:{
                ...data,
                created_uid:uid,
                created_at:date,
                created_at_server:firebase.database.ServerValue.TIMESTAMP
              }
              let available = path_invalid?true:false
              if (!available) {
                let check_key = await dispatch('fi_check_key',{path:path})
                available = check_key?check_key.available:null 
              }
              if (available) {
                let res = await PATH_REF.set(record)
                response.success = true,
                response.data = res
                if (!download_data) {
                  commit('updateLoading', false)
                  commit('updateProcesses', { 
                    name: 'setting/'+action
                  })
                  commit('updateResponses', {
                    res: 'setting/'+action+'/successful',
                    val: response
                  }) 
                  resolve(response) 
                } else {
                  let downloaded_data = null
                  await PATH_REF.once('value', async(snapshot) => {
                    downloaded_data = await snapshot.val() 
                  }) 
                  response.downloaded_data = downloaded_data 
                  commit('updateLoading', false)
                  commit('updateProcesses', { 
                    name: 'setting/'+action
                  })
                  commit('updateResponses', {
                    res: 'setting/'+action+'/successful',
                    val: response
                  }) 
                  resolve(response) 
                }
              } else {
                response.error="path not available"
                response.payload=payload
                response.uid=uid
                response.data=check_key
                commit('updateLoading', false)
                commit('updateProcesses', { 
                  name: 'setting/'+action
                })
                commit('updateResponses', {
                  res: 'setting/'+action+'/error',
                  val: "no action"
                })
                commit("ERROR",response)
                reject(response)
              } 
            } else {
              response.error="payload required"
              response.payload=payload
              response.uid=uid
              commit('updateLoading', false)
              commit('updateProcesses', { 
                name: 'setting/'+action
              })
              commit('updateResponses', {
                res: 'setting/'+action+'/error',
                val: "no action"
              })
              commit("ERROR",response)
              reject(response)
            } 
          } catch (error) {
            response.error = error
            response.payload = payload
            commit('updateLoading', false)
            commit('updateProcesses', { 
              name: 'setting/'+action
            })
            commit('updateResponses', {
              res: 'setting/'+action+'/error',
              val: response
            }) 
            commit("ERROR",response)
            reject(response)
          }  
        })
      },
      fs_set({ commit}, payload) {
        try {
          let action = payload.action
          let path = payload.path
          let data = payload.data
          let us = users?users.state.USER:null
          let uid = us?us.uid:null 
          if (!uid) {
            commit('updateResponses', {
              res: 'adding/'+action+'/error',
              val: "no action"
            })
            console.log("no uid.....");
            return
          }
          let array = payload.array 
          
          //not
          commit('updateLoading', true)
          commit('updateProcesses', {
            add: true,
            name: 'setting/'+action
          }) 
          if (action) { 
            let dt = new Date
            let date = dt.toISOString()
            let record =array?data:{
              ...data,
              created_uid:uid,
              updated_at:date,
              created_at_server:firebase.firestore.FieldValue.serverTimestamp()
            }
            let ref = firebase.firestore().collection(path).set(record)
            ref.then(res => {
              //not
              commit('updateLoading', false)
              commit('updateProcesses', { 
                name: 'setting/'+action
              })
              commit('updateResponses', {
                res: 'setting/'+action+'/successful',
                val: res
              })
            }).catch(error => {
              //not
              commit('updateLoading', false)
              commit('updateProcesses', { 
                name: 'setting/'+action
              })
              commit('updateResponses', {
                res: 'setting/'+action+'/error',
                val: error
              })
              commit("ERROR",{
                page:NAME,
                from:"fi_set",
                error:error
              })
            })
          } else {
            //not
            commit('updateLoading', false)
            commit('updateProcesses', { 
              name: 'setting/'+action
            })
            commit('updateResponses', {
              res: 'setting/'+action+'/error',
              val: "no action"
            })
            commit("ERROR",{
              page:NAME,
              from:"fs_set",
              error:'no user'
            })
          } 
        } catch (error) {
          commit("ERROR",{
            error:error,
            from:'fs_set',
            page:NAME, 
          })
        }
      },

      //-----------------[ FI DELETE]------------
      fi_delete({ commit}, payload) {
        return new Promise((resolve,reject)=>{
          try {
            let action = payload.action
            let path = payload.path  
    
            //not
            commit('updateLoading', true)
            commit('updateProcesses', {
              add: true,
              name: 'deleting/'+action
            }) 
            if (action) {  
              let ref = firebase.database().ref(path).set(null)
              ref.then(res => {
                //not
                commit('updateLoading', false)
                commit('updateProcesses', { 
                  name: 'deleting/'+action
                })
                commit('updateResponses', {
                  res: 'deleting/'+action+'/successful',
                  val: res
                })
                resolve({
                  response:'success',
                  deleted:true
                })
              }).catch(error => {
                //not
                commit('updateLoading', false)
                commit('updateProcesses', { 
                  name: 'deleting/'+action
                })
                commit('updateResponses', {
                  res: 'deleting/'+action+'/error',
                  val: error
                })
                commit("ERROR",{
                  page:NAME,
                  from:"fi_delete",
                  error:error
                })
                reject({
                  response:'failed',
                  error:error
                })
              })
            } else {
              //not
              commit('updateLoading', false)
              commit('updateProcesses', { 
                name: 'deleting/'+action
              })
              commit('updateResponses', {
                res: 'deleting/'+action+'/error',
                val: "no action"
              })
              commit("ERROR",{
                page:NAME,
                from:"fi_delete",
                error:'no user'
              })
              reject({
                response:'failed',
                error:'no user'
              })
            } 
          } catch (error) {
            commit("ERROR",{
              error:error,
              from:'fi_delete',
              page:NAME, 
            })
            reject({
              response:'failed',
              error:error
            })
          } 
        })
      },
      fs_delete({ commit}, payload) {
        try {
          let action = payload.action
          let path = payload.path  
        
          //not
          commit('updateLoading', true)
          commit('updateProcesses', {
            add: true,
            name: 'deleting/'+action
          }) 
          if (action) {  
          
            let ref = firebase.firestore().doc(path).delete()
            ref.then(res => {
            
              //not
              commit('updateLoading', false)
              commit('updateProcesses', { 
                name: 'deleting/'+action
              })
              commit('updateResponses', {
                res: 'deleting/'+action+'/successful',
                val: res
              })
            }).catch(error => {
            
              //not
              commit('updateLoading', false)
              commit('updateProcesses', { 
                name: 'deleting/'+action
              })
              commit('updateResponses', {
                res: 'deleting/'+action+'/error',
                val: error
              })
              commit("ERROR",{
                page:NAME,
                from:"fi_delete",
                error:error
              })
            })
          } else {
            //not
            commit('updateLoading', false)
            commit('updateProcesses', { 
              name: 'deleting/'+action
            })
            commit('updateResponses', {
              res: 'deleting/'+action+'/error',
              val: "no action"
            })
            commit("ERROR",{
              page:NAME,
              from:"fi_delete",
              error:'no user'
            })
          } 
        } catch (error) {
          commit("ERROR",{
            error:error,
            from:'fs_delete',
            page:NAME, 
          })
        }
      },
      fi_deleteImage({commit},payload){ 
        try {
          let link = payload.link
          let action = payload.action
          let path = payload.path
          let uid = users.state.USER.uid
          let ext = 'jpeg'
          let storeRef = firebase.storage().refFromURL(link)
          //not
          commit('updateLoading', true)
          commit('updateProcesses', {
            add: true,
            name: 'deleting/image/'+action 
          })
          if (uid!=null) {   
            storeRef.delete() 
            .then( ()=> {  
              return firebase.database().ref(path).update({ 
                image:null
              })
            }) 
            .then(data => {
              commit('updateLoading', false)
              commit('updateProcesses', { 
                name: 'deleting/image/'+action 
              })
              commit('updateResponses', {
                res: 'deleting/image/'+action+'/successful',
                val: data
              }) 
            }).catch(error => {
              
              if (error.code ==="storage/object-not-found") {
                console.log(path,error);
                firebase.database().ref(path).update({ 
                  image:null
                })
                .then(data => {
                  commit('updateLoading', false)
                  commit('updateProcesses', { 
                    name: 'deleting/image/'+action 
                  })
                  commit('updateResponses', {
                    res: 'deleting/image/'+action+'/successful',
                    val: data
                  }) 
                })
                .catch(error2=>{
                  commit('updateLoading', false)
                  commit('updateProcesses', { 
                    value: 'deleting/image/'+action 
                  })
                  commit('updateResponses', {
                    res: 'deleting/image/'+action+'/error',
                    val: error2
                  }) 
                  commit("ERROR",{
                    page:NAME,
                    from:"fi_deleteImage",
                    error:error2
                  })
                })
              } else {
                console.log(error);
                commit('updateLoading', false)
                commit('updateProcesses', { 
                  value: 'deleting/image/'+action 
                })
                commit('updateResponses', {
                  res: 'deleting/image/'+action+'/error',
                  val: error
                }) 
                commit("ERROR",{
                  page:NAME,
                  from:"fi_deleteImage",
                  error:error
                })
              }
              
            }) 
          }else{ 
            commit('updateLoading', false) 
            commit('updateProcesses', { 
              name: 'deleting/image/'+action 
            })
            commit('updateResponses', {
              res: 'deleting/image/'+action+'/error',
              val: 'no user'
            })
            commit("ERROR",{
              page:NAME,
              from:"fi_deleteImage",
              error:'no user'
            })
          } 
        } catch (error) {
          commit("ERROR",{
            error:error,
            from:'fi_uploadImage',
            page:NAME, 
          })
        }
      },
      fs_deleteImage({commit},payload){ 
        try {
          let link = payload.link
          let action = payload.action
          let path = payload.path
          let child = payload.child
          let array = payload.array
          let uid = users.state.USER.uid
          let ext = 'jpeg'
          let storeRef = firebase.storage().refFromURL(link)
          //not
          commit('updateLoading', true)
          commit('updateProcesses', {
            add: true,
            name: 'deleting/image/'+action 
          })
          if (uid!=null) {   
            storeRef.delete() 
            .then( ()=> {  
              let imgRef = firebase.firestore().doc(""+path)
              let updateData = {}
              updateData[child] = null
              if (array) {
                updateData[child] = array
              }
              return imgRef.update(updateData)
               
            }) 
            .then(data => {
              commit('updateLoading', false)
              commit('updateProcesses', { 
                name: 'deleting/image/'+action 
              })
              commit('updateResponses', {
                res: 'deleting/image/'+action+'/successful',
                val: data
              }) 
            }).catch(error => {
              
              if (error.code ==="storage/object-not-found") {
                console.log(path,error);
                firebase.database().ref(path).update({ 
                  image:null
                })
                .then(data => {
                  commit('updateLoading', false)
                  commit('updateProcesses', { 
                    name: 'deleting/image/'+action 
                  })
                  commit('updateResponses', {
                    res: 'deleting/image/'+action+'/successful',
                    val: data
                  }) 
                })
                .catch(error2=>{
                  commit('updateLoading', false)
                  commit('updateProcesses', { 
                    value: 'deleting/image/'+action 
                  })
                  commit('updateResponses', {
                    res: 'deleting/image/'+action+'/error',
                    val: error2
                  }) 
                  commit("ERROR",{
                    page:NAME,
                    from:"fs_deleteImage",
                    error:error2
                  })
                })
              } else {
                console.log(error);
                commit('updateLoading', false)
                commit('updateProcesses', { 
                  value: 'deleting/image/'+action 
                })
                commit('updateResponses', {
                  res: 'deleting/image/'+action+'/error',
                  val: error
                }) 
                commit("ERROR",{
                  page:NAME,
                  from:"fs_deleteImage",
                  error:error
                })
              }
              
            }) 
          }else{ 
            commit('updateLoading', false) 
            commit('updateProcesses', { 
              name: 'deleting/image/'+action 
            })
            commit('updateResponses', {
              res: 'deleting/image/'+action+'/error',
              val: 'no user'
            })
            commit("ERROR",{
              page:NAME,
              from:"fs_deleteImage",
              error:'no user'
            })
          } 
        } catch (error) {
          commit("ERROR",{
            error:error,
            from:'fs_deleteImage',
            page:NAME, 
          })
        }
      },
      fi_deleteAllImages({commit,dispatch},payload){ 
        try {
          let action = payload.action
          let path = payload.path
          let uid = users.state.USER.uid 
          let disp = payload.dispatch
          let dispData = payload.dispatchData
  
          let storeRef = firebase.storage().ref(path) 
          //not
          commit('updateLoading', true)
          commit('updateProcesses', {
            add: true,
            name: 'deleting/image/'+action 
          })
          if (uid!=null) {  
            //IF USER 
            storeRef.listAll()
            .then(RESULTS=>{
              let itemSize = RESULTS.items.length
              let NUMBER = 0 
              console.log(itemSize); 
              RESULTS.items.forEach(item => {
                NUMBER = NUMBER+1
                let imageRef = firebase.storage().ref(item.fullPath)
                if (NUMBER===itemSize) { 
                  return imageRef.delete() 
                } else { 
                  imageRef.delete() 
                } 
              });
            })
            .then(data => {
              if (disp) {
                dispatch(disp,dispData)
              }
              commit('updateLoading', false)
              commit('updateProcesses', { 
                name: 'deleting/image/'+action 
              })
              commit('updateResponses', {
                res: 'deleting/image/'+action+'/successful',
                val: data
              }) 
            })
            .catch(error=>{
              commit('updateLoading', false)
              commit('updateProcesses', { 
                value: 'deleting/image/'+action 
              })
              commit('updateResponses', {
                res: 'deleting/image/'+action+'/error',
                val: error
              }) 
              commit("ERROR",{
                page:NAME,
                from:"fi_deleteAllImages",
                error:error
              })
            })
            
          }else{ 
            commit('updateLoading', false) 
            commit('updateProcesses', { 
              name: 'deleting/image/'+action 
            })
            commit('updateResponses', {
              res: 'deleting/image/'+action+'/error',
              val: 'no user'
            })
            commit("ERROR",{
              page:NAME,
              from:"fi_deleteAllImages",
              error:'no user'
            })
          } 
        } catch (error) {
          commit("ERROR",{
            error:error,
            from:'fi_deleteAllImages',
            page:NAME, 
          })
        } 
      }, 

      //-----------------[ SAVE ]--------------\ 
      join_items({commit,dispatch},payload){
        return new Promise((resolve,reject)=>{
          let response = {
            from:'join_items',
            page:NAME, 
            payload:payload
          }
          try {
            let name = payload.name
            let item = payload.item
            let items = payload.items  
            if (!name) {
              commit("ERROR",{
                ...response,
                error:{
                  error:'no name',
                  data:payload
                },
               
              })
              response.error = "no name or data"
              reject(response)
              return
            }   
 
            //join 
            // let joined = JOIN({
            //   name:name,
            //   items:items,
            //   item:item,
            // }) 
            // commit("setItems",{
            //   name:"JOINED_"+name.toUpperCase(),
            //   data:joined
            // }) 
            resolve({success:true}) 
          } catch (error) {
            response.error = error
            commit("ERROR",{
              ...response,
              error:error,
            })
            reject.apply(response)
          }
        })
      }, 
      f_save_items({commit,dispatch,state},payload){
        return new Promise((resolve,reject)=>{
          let response = {
            from:'f_save_items',
            page:NAME, 
            payload:payload
          }
          try {
            let name = payload.name
            let action = payload.action
            let data = payload.data 
            let fi_data = payload.fi_data 
            let cash = payload.cash 
            let db = payload.db 
            let child_keys = payload.child_keys 
            let isChild = child_keys?true:false
            let isCompany = false
            if (!name) {
              commit("ERROR",{
                error:{
                  error:'no name---',
                  data:payload
                },
                from:'f_save_items',
                page:NAME, 
              })
              response.error = "no name"
              reject(response)
              return
            } 
            if (!action) {
              action = name
            } 
  
            if (true) { 
              commit('updateProcesses', {name: 'getting/'+action})  

              let items = []
              let all_items = []
              let archived_items = []
              let i = 1

              if (db || isChild) { 
                for (const item of data) { 
                  all_items.push(item)
                  if (item.archive) {
                    archived_items.push(item)
                  }else{
                    items.push(item)
                  }   
                }  
              }else{ 
                // -------------[CHANGE OBJECT TO ARRAY]------------
                let obj = data   
                if (TEXT_UP(name)) {
                  for (const key in obj) {
                    let item = obj[key] 
                    let item_type = typeof item  
                    if (item_type == "number") {
                      item = {
                        i:i,
                        key:key,
                        number : item
                      } 
                    }else {
                      item = {
                        i:i,
                        key:key,
                        ...item
                      } 
                    }
                    all_items.push(item)
                    if (item.archive) {
                      archived_items.push(item)
                    }else{
                      items.push(item)
                    }  
                    i++
                  }    
                }
              }
              
              if (cash) { 
                if (name.toUpperCase()){
                  DB.addItems({
                    name:name,
                    data:all_items,
                    clear:isCompany||isChild?false:true,
                  })
                  .then(response=>{
                    //success
                  }).catch(error=>{
                    // commit("ERROR",{
                    //   error:error,
                    //   from:'f_save_items',
                    //   page:NAME, 
                    // })
                    console.log(error,".....e");
                  })  
                }
              }

              //save data
              if (name.toUpperCase()===DATA.ITEMS.ERRORS.values.toUpperCase()) { 
                state.ERRORS = all_items     
              }else if (name) { 
                commit("setItems",{
                  name:name.toUpperCase(),
                  data:items
                })
                commit("setItems",{
                  name:"ARCHIVED_"+name.toUpperCase(),
                  data:archived_items
                })
                commit("setItems",{
                  name:"ALL_"+name.toUpperCase(),
                  data:all_items
                })
              }else{
                commit("ERROR",{
                  error:{
                    error:'name not found',
                    data:payload
                  },
                  from:'f_save_items',
                  page:NAME, 
                })
                response.error = "name not found"
                reject(response)
              }  
              resolve({success:true})
            } 
          } catch (error) {
            response.error = error
            // commit("ERROR",{
            //   error:error,
            //   from:'f_save_items',
            //   page:NAME, 
            // })
            console.log(response);
            reject.apply(response)
          }
        })
      },  
      add_items({ commit,dispatch,state},payload) {
        let response = {
          from:'add_items',
          page:NAME, 
          payload:payload
        }
        return new Promise(async(resolve,reject)=>{
          try { 
            let name = payload?payload.name:null  
            let data = payload?payload.data:null  
            
            if (!name) { 
              response = {
                error:"payload required"
              } 
              commit("ERROR",response)
              reject(response)
              return  
            }  

            commit("setItems",{
              name:name.toUpperCase(),
              data:data
            }) 
            resolve({
              success:true, 
            })
          } catch (error) { 
            response = {
              error:error,
              ...response
            } 
            commit("ERROR",response)
            reject(response)  
          }  
        })
      },
      
      //-----------------[ FI GET ]--------------\   
      fi_get_item({ commit,dispatch,state},payload) { 
        return new Promise(async(resolve,reject)=>{
          let response = {
            from:'fi_get_item',
            page:NAME, 
            payload:payload
          }
          try { 
            let name = payload?payload.name:null
            let action = payload?payload.action:null
            let on = payload?payload.on:null 
            let cash = payload?payload.cash:null 
            let get = payload?payload.get:null  
            let child_keys = payload?payload.child_keys:null
            let local_child_keys = payload?payload.local_child_keys:null
            let ITEM_REF = null 
            if (name) {
              if (!action) {action=name}
              if (get) {
                commit('updateProcesses', {
                  add: true,
                  name: 'local_getting/'+name
                }) 
                commit('advanceProcess', {
                  name: name,
                  action: 'local_getting', 
                  loading: true,
                }) 
                DB.getItems({
                  name:name, 
                  // update_store:true,
                })
                .then(res=>{
                  commit('updateProcesses', { 
                    name: 'local_getting/'+name
                  }) 
                  commit('advanceProcess', {
                    name: name,
                    action: 'local_getting', 
                    loading: false,
                  }) 
                  dispatch("f_save_items",{
                    name:name,
                    data:res.data,
                    db:true
                  }) 
                }).catch(error=>{
                  commit('updateProcesses', { 
                    name: 'local_getting/'+name
                  })
                  commit('advanceProcess', {
                    name: name,
                    action: 'local_getting', 
                    loading: false,
                  }) 
                  commit("ERROR",{
                    error:{
                      error:{
                        error:error,
                        name:'local db',
                      },
                      data:payload
                    },
                    from:'f_get_items',
                    page:NAME, 
                  })
                })  
              } 
              commit('updateProcesses', {
                add: true,
                name: 'getting/'+name
              })  
              commit('advanceProcess', {
                name: name,
                action: child_keys?'getting_keys':'getting', 
                loading: true,
              })  
              if (name.toUpperCase()===DATA.ITEMS.ERRORS.values.toUpperCase()) {
                ITEM_REF = REF_ERRORS  
              }else if (name.toUpperCase()===DATA.ITEMS.MESSAGES.values.toUpperCase()) {
                ITEM_REF = REF_MESSAGES   
              }else if (name.toUpperCase()===DATA.ITEMS.ID_TYPES.values.toUpperCase()) { 
                ITEM_REF = REF_ID_TYPES
              }else if (name.toUpperCase()===DATA.ITEMS.OCCURRENCES.values.toUpperCase()) {
                ITEM_REF = REF_OCCURRENCES
              }else if (name.toUpperCase()===DATA.ITEMS.REPORTERS.values.toUpperCase()) {
                ITEM_REF = REF_REPORTERS
              }else if (name.toUpperCase()===DATA.ITEMS.REPORTER_CATEGORIES.values.toUpperCase()) {
                ITEM_REF = REF_REPORTER_CATEGORIES
              }else if (name.toUpperCase()===DATA.ITEMS.WEB_REPORTS.values.toUpperCase()) {
                ITEM_REF = REF_WEB_REPORTS
              }else if (name.toUpperCase()===DATA.ITEMS.WHATSAPP_REPORTS.values.toUpperCase()) {
                ITEM_REF = REF_WHATSAPP_REPORTS
              }else if (name.toUpperCase()===DATA.ITEMS.MOBILE_REPORTS.values.toUpperCase()) {
                ITEM_REF = REF_MOBILE_REPORTS
              }else if (name.toUpperCase()===DATA.ITEMS.SMS_REPORTS.values.toUpperCase()) {
                ITEM_REF = REF_SMS_REPORTS 
              }else if (name.toUpperCase()===DATA.ITEMS.PERSONAL_REPORTS.values.toUpperCase()) {
                ITEM_REF = REF_PERSONAL_REPORTS 
              } 
              
              else if (name.toUpperCase()===DATA.ITEMS.COUNTRIES.values.toUpperCase()) {
                ITEM_REF = REF_COUNTRIES    
              }else if (name.toUpperCase()===DATA.ITEMS.REGIONS.values.toUpperCase()) {
                ITEM_REF = REF_REGIONS    
              }else if (name.toUpperCase()===DATA.ITEMS.DISTRICTS.values.toUpperCase()) {
                ITEM_REF = REF_DISTRICTS    
              }else if (name.toUpperCase()===DATA.ITEMS.CONSTITUENCIES.values.toUpperCase()) {
                ITEM_REF = REF_CONSTITUENCIES   
              }else if (name.toUpperCase()===DATA.ITEMS.WARDS.values.toUpperCase()) {
                ITEM_REF = REF_WARDS  
              }else if (name.toUpperCase()===DATA.ITEMS.CENTRES.values.toUpperCase()) {
                ITEM_REF = REF_CENTRES  
              }else if (name.toUpperCase()===DATA.ITEMS.TRADITION_AUTHORITIES.values.toUpperCase()) {
                ITEM_REF = REF_TRADITION_AUTHORITIES 
              }
              
              else if (name.toUpperCase()===DATA.ITEMS.QUESTION_TYPES.values.toUpperCase()) {
                ITEM_REF = REF_QUESTION_TYPES 
              }else if (name.toUpperCase()===DATA.ITEMS.QUESTION_CATEGORIES.values.toUpperCase()) {
                ITEM_REF = REF_QUESTION_CATEGORIES
              }else if (name.toUpperCase()===DATA.ITEMS.QUESTION_TIMELINES.values.toUpperCase()) {
                ITEM_REF = REF_QUESTION_TIMELINES
              }else if (name.toUpperCase()===DATA.ITEMS.QUESTION_STAGES.values.toUpperCase()) {
                ITEM_REF = REF_QUESTION_STAGES
              }else if (name.toUpperCase()===DATA.ITEMS.QUESTIONNAIRES.values.toUpperCase()) {
                ITEM_REF = REF_QUESTIONNAIRES
              }else if (name.toUpperCase()===DATA.ITEMS.REPORTS.values.toUpperCase()) {
                ITEM_REF = REF_REPORTS
              }
                
              //GET REF
              if (ITEM_REF) {
                let ref_action = {
                  name:name, 
                  action:action,  
                  cash:cash,  
                  child_keys:child_keys, 
                }
                if (on) {   
                  ITEM_REF.on('value', async snapshot => {
                    let fi_data = snapshot
                    let data = snapshot.val() 
                    await dispatch('f_save_items',{...ref_action,data:data,fi_data:fi_data})
                  })  
                  resolve({success:true}) 
                } else { 
                  if (child_keys) { 
                    let finLocalKey = key=>{
                      if(!local_child_keys){return null}
                      return local_child_keys.find(record=>record.key == key)
                    }
                    let update_records = []
                    let changed_keys = [] 
                    // find changed keys
                    for (const child_key of child_keys) { 
                      let local_key = finLocalKey(child_key.key)
                      let local_key_update = toNumber(local_key?local_key.updates:null)
                      let key_update = toNumber(child_key?child_key.updates:null)
                      
                      if (!local_key || (key_update!=local_key_update)) {
                        changed_keys.push(child_key.key)
                        //console.log(child_key.key,local_key_update,key_update,'update!........'); 
                      }else{
                        //console.log(child_key.key,local_key_update,key_update,'same!........');
                      } 
                    }

                    //get changed key
                    let changed_keys_size = changed_keys.length
                    console.log(changed_keys_size,"changed_keys_size.....");
                    if (changed_keys_size<100) {
                      console.log(changed_keys,'Download Keys ..........',name); 
                      for (const child_key of changed_keys) {  
                        let snapshot = await ITEM_REF.child(child_key).once('value')
                        let data = snapshot?snapshot.val():null
                        update_records.push({...data,key:child_key})  
                      } 
                    }else{
                      console.log(changed_keys,'More Keys ..........',name); 
                      commit('updateProcesses', { 
                        name: 'getting/'+name
                      }) 
                      await dispatch('fi_get_item',{ 
                        name:name,
                        cash:cash, 
                      }) 
                      resolve({success:true}) 
                      return
                    } 

                    //update changes
                    if (update_records.length>0) {
                      console.log(update_records,'snapshot.....'); 
                      let state_data = state[TEXT_UP(name)]
                      if (state_data) {
                        update_records = await dispatch('combine_data',{
                          data1:[...state_data],
                          data2:update_records
                        })   
                      }
                      if (update_records) { 
                        await dispatch('f_save_items',{...ref_action,data:update_records}) 
                      }
                    }else{ 
                      console.log(update_records,'no record.....',name); 
                      commit('updateProcesses', { 
                        name: 'getting/'+name
                      }) 
                      await dispatch('fi_get_item',{ 
                        name:name,
                        cash:cash, 
                      })
                      resolve({success:true}) 
                      return
                    }

                    resolve({success:true,data:update_records,child_keys:child_keys}) 
                  }else{
                    ITEM_REF.once('value').then(async snapshot => {
                      let fi_data = snapshot
                      let data = snapshot.val()
                      await dispatch('f_save_items',{...ref_action,data:data,fi_data:fi_data})
                      resolve({success:true,data:data,fi_data:fi_data}) 
                    }).catch(error=>{
                      response.error = error 
                      reject(response)
                    })
                  }
                }   
              }else{
                response.error = "no ref"
                commit("ERROR",{
                  error:{
                    error:'name not found',
                    data:payload
                  },
                  from:'f_get_items',
                  page:NAME, 
                })
                reject(response)
              } 
            } else {
              response.error = "no name"
              commit("ERROR",{
                error:{
                  error:"No name",
                  data:payload
                },
                from:'fi_get_items',
                page:NAME, 
              })
              reject(response)
            }
          } catch (error) {
            response.error = error
            commit("ERROR",{
              error:error,
              from:'fi_get_item',
              page:NAME, 
            })
            reject(response)
          } 
        })
      }, 
      fi_check_key({ commit,dispatch},payload) {
        return new Promise(async(resolve,reject)=>{
          let response = {
            from:'fi_get_item',
            page:NAME, 
          }
          try { 
            let key = payload?payload.key:null
            let path = payload?payload.path:null 
            if (path) { 
              if (key) {
                if (path.slice(path.length - 1)=="/") {
                  path = path+key
                } else {
                  path = path+"/"+key
                }
              }
              commit('updateLoading', true)
              commit('updateProcesses', {
                add: true,
                name: 'checking/key'
              })  
              let PATH_REF = firebase.database().ref(path)
              await PATH_REF.once('value', async(snapshot) => {
                let data = await snapshot.val()
                response = {
                  success:true,
                  data:data,
                  path:path,
                  available:data?false:true
                }
              })  
              console.log(payload,response,'res..................');
              //not
              commit('updateLoading', false)
              commit('updateProcesses', { 
                name: 'checking/key'
              })
              commit('updateResponses', response)
              resolve(response)
            } else { 
              response = {
                error:"no key or path",
                payload:payload,
                from:'fi_check_key',
                page:NAME, 
              }
            }
          } catch (error) { 
            response = {
              error:error,
              payload:payload,
              from:'fi_check_key',
              page:NAME, 
            } 
            commit("ERROR",response)
          }  
          reject(response)  
        })
      },
      fi_get_path_data({ commit,dispatch},payload) {
        return new Promise(async(resolve,reject)=>{
          let response = {
            from:'fi_get_path_data',
            page:NAME, 
          }
          try { 
            let key = payload?payload.key:null
            let path = payload?payload.path:null 
            if (path) { 
              if (key) {
                if (path.slice(path.length - 1)=="/") {
                  path = path+key
                } else {
                  path = path+"/"+key
                }
              }
              commit('updateLoading', true)
              commit('updateProcesses', {
                add: true,
                name: 'checking/key'
              })  
              let PATH_REF = firebase.database().ref(path)
              await PATH_REF.once('value', async(snapshot) => {
                let data = await snapshot.val()
                response = {
                  success:true,
                  data:data,
                  path:path,
                  available:data?false:true
                }
              })  
              console.log(payload,response,'res..................');
              //not
              commit('updateLoading', false)
              commit('updateProcesses', { 
                name: 'checking/key'
              })
              commit('updateResponses', response)
              resolve(response)
            } else { 
              response = {
                error:"no key or path",
                payload:payload,
                from:'fi_get_path_data',
                page:NAME, 
              }
            }
          } catch (error) { 
            response = {
              error:error,
              payload:payload,
              from:'fi_get_path_data',
              page:NAME, 
            } 
            commit("ERROR",response)
          }  
          reject(response)  
        })
      }, 

      //-----------------[LOCAL UPDATE]
      update_from_db({commit,state},payload) {
        return new Promise((resolve,reject)=>{
          let response = {
            from:'update_from_db',
            page:NAME,
            payload:payload
          }
          try {   
            let name = payload?payload.name:''
            
            if (name.toUpperCase()===DATA.ITEMS.ITEMS.values.toUpperCase()) {
              // DB.getItems({
              //   name:DATA.ITEMS.LOCAL_SALE_ORDERS.values,
              //   update_from_db:true
              // }).then(async res=>{ 
              //   let orders = res?res.data:null
              //   if (orders) {
              //     let sale_orders = state.SALE_ORDERS
              //     sale_orders = sale_orders?sale_orders.filter(item=>{
              //       return !item.offline_version 
              //     }):[]
              //     orders.forEach(element => {
              //       sale_orders.push({
              //         ...element,
              //         offline_version:true
              //       })
              //     }); 
              //     state.SALE_ORDERS = sale_orders
              //   }
              //   resolve({
              //     success:true,
              //     updated:true
              //   }) 
              // }).catch(error=>{
              //   response.error = error
              //   commit("ERROR",response)
              //   reject(response)
              // })
            } else {
              resolve({
                success:true
              }) 
            } 
          } catch (error) {
            response.error = error
            commit("ERROR",response)
            reject(response)
          } 
        })
      },  
      update_local_item({ commit,state}, payload) {
        try {
          let key = payload.key
          let value_item = payload.value_item
          let data = payload.data 
          let items = null
          
          if (!key) {
            commit("ERROR",{
              error:{
                error:'updating/local_item/error',
                data:payload
              },
              from:'update_local_item',
              page:NAME, 
            })
            return
          }if (!value_item) {
            commit("ERROR",{
              error:{
                error:'updating/local_item/error',
                data:payload
              },
              from:'update_local_item',
              page:NAME, 
            })
            return
          }if (!data) {
            commit("ERROR",{
              error:{
                error:'updating/local_item/error',
                data:payload
              },
              from:'update_local_item',
              page:NAME, 
            })
            return
          } 
          value_item = value_item.toUpperCase()

          if (value_item==='PROVINCES'||value_item==='PROVINCE') {
            items = [...state.PROVINCES]
          }else if(value_item==='DISTRICTS'||value_item==='DISTRICT') {
            items = [...state.DISTRICTS]
          }else if(value_item==='CONSTITUENCIES'||value_item==='CONSTITUENCY') {
            items = [...state.CONSTITUENCIES]
          }else if(value_item==='POLLING_STATIONS'||value_item==='POLLING_STATION') {
            items = [...state.POLLING_STATIONS]
          }else if(value_item==='REPORTS'||value_item==='REPORT') {
            items = [...state.REPORTS]
          }else if(value_item==='SMS'||value_item==='sms') {
            items = [...state.SMS]
          }else if(value_item==='REPORT_CATEGORIES'||value_item==='REPORT_CATEGORY') {
            items = [...state.REPORT_CATEGORIES]
          }else if(value_item==='POLLS'||value_item==='POLL') {
            items = [...state.POLLS]
          }else if(value_item==='NEWS'||value_item==='NEWS') {
            items = [...state.NEWS]
          } 

          let item_size = items?items.length:0
          if (item_size>0) {
            var foundIndex = items.findIndex(x => x.key == key);
             
            items[foundIndex] = {
              ...items[foundIndex],
              ...data
            }

            if (value_item==='PROVINCES'||value_item==='PROVINCE') {
              state.PROVINCES=items 
            }else if(value_item==='DISTRICTS'||value_item==='DISTRICT') {
              state.DISTRICTS=items 
            }else if(value_item==='CONSTITUENCIES'||value_item==='CONSTITUENCY') {
              state.CONSTITUENCIES=items 
            }else if(value_item==='POLLING_STATIONS'||value_item==='POLLING_STATION') {
              state.POLLING_STATIONS=items 
            }else if(value_item==='REPORTS'||value_item==='REPORT') {
              state.REPORTS=items 
            }else if(value_item==='SMS'||value_item==='sms') {
              state.SMS=items 
            }else if(value_item==='REPORT_CATEGORIES'||value_item==='REPORT_CATEGORY') {
              state.REPORT_CATEGORIES=items 
            }else if(value_item==='POLLS'||value_item==='POLL') {
              state.POLLS=items 
            }else if(value_item==='NEWS'||value_item==='NEWS') {
              state.NEWS=items 
            }  

          }else { 
            commit("ERROR",{
              error:{
                error:"No reports",
                data:payload,
                items:items
              },
              from:'update_local_item',
              page:NAME, 
            })
          } 
        } catch (error) {
          commit("ERROR",{
            error:{
              error:error,
              data:payload
            },
            from:'update_local_item',
            page:NAME, 
          })
        }
      }, 
      add_local_item({ commit,state}, payload) {
        try {
          let key = payload.key
          let value_item = payload.value_item
          let data = payload.data 
          let items = []
 
          
          if (!key) {
            commit("ERROR",{
              error:{
                error:'No key',
                data:payload
              },
              from:'add_local_item',
              page:NAME, 
            })
            return
          }if (!value_item) {
            commit("ERROR",{
              error:{
                error:'no value',
                data:payload
              },
              from:'add_local_item',
              page:NAME, 
            })
            return
          }if (!data) {
            commit("ERROR",{
              error:{
                error:'no data',
                data:payload
              },
              from:'add_local_item',
              page:NAME, 
            })
            return
          } 
          value_item = value_item.toUpperCase()

          if (value_item==='PROVINCES'||value_item==='PROVINCE') {
            items = [...state.PROVINCES]
          }else if(value_item==='DISTRICTS'||value_item==='DISTRICT') {
            items = [...state.DISTRICTS]
          }else if(value_item==='CONSTITUENCIES'||value_item==='CONSTITUENCY') {
            items = [...state.CONSTITUENCIES]
          }else if(value_item==='POLLING_STATIONS'||value_item==='POLLING_STATION') {
            items = [...state.POLLING_STATIONS]
          }else if(value_item==='REPORTS'||value_item==='REPORT') {
            items = [...state.REPORTS]
          }else if(value_item==='SMS'||value_item==='sms') {
            items = [...state.SMS]
          }else if(value_item==='REPORT_CATEGORIES'||value_item==='REPORT_CATEGORY') {
            items = [...state.REPORT_CATEGORIES]
          }else if(value_item==='POLLS'||value_item==='POLL') {
            items = [...state.POLLS]
          }else if(value_item==='NEWS'||value_item==='NEWS') {
            items = [...state.NEWS]
          } 

          let item_size = items?items.length:0
          if (item_size===0) { 
             item = []
          }

          items.push({
            key:key,
            ...data
          })

          if (value_item==='PROVINCES'||value_item==='PROVINCE') {
            state.PROVINCES=items 
          }else if(value_item==='DISTRICTS'||value_item==='DISTRICT') {
            state.DISTRICTS=items 
          }else if(value_item==='CONSTITUENCIES'||value_item==='CONSTITUENCY') {
            state.CONSTITUENCIES=items 
          }else if(value_item==='POLLING_STATIONS'||value_item==='POLLING_STATION') {
            state.POLLING_STATIONS=items 
          }else if(value_item==='REPORTS'||value_item==='REPORT') {
            state.REPORTS=items 
          }else if(value_item==='SMS'||value_item==='sms') {
            state.SMS=items 
          }else if(value_item==='REPORT_CATEGORIES'||value_item==='REPORT_CATEGORY') {
            state.REPORT_CATEGORIES=items 
          }else if(value_item==='POLLS'||value_item==='POLL') {
            state.POLLS=items 
          }else if(value_item==='NEWS'||value_item==='NEWS') {
            state.NEWS=items 
          }  
            
        } catch (error) {
          commit("ERROR",{
            error:{
              error:error,
              data:payload
            },
            from:'update_local_item',
            page:NAME, 
          })
        }
      }, 
    },
}